import { css } from '@emotion/react'
import Colors from '../../utils/colors'

const Styles = ({ colors }) => {
  const { primary, third } = Colors()
  const { scales: { grayShades } } = colors
  return ({
    container: css`
      padding: 3.75rem 0;
      text-align: center;
      display:flex;
      justify-content: center;
      align-items:center;
      flex-direction: column;
      flex-wrap:wrap;
      clip-path: ellipse(122% 100% at 50% 100%);
      background: linear-gradient(to bottom, ${primary} 60%, ${third} 40%);
      @media (max-width: 767px) {
        flex-direction: column;
        padding: 2.5rem 1rem;
        clip-path: ellipse(250% 100% at 50% 100%);
      }
    `,
    subContainer: css`
      max-width: 68rem;
      margin: 0 auto;
      @media (max-width: 767px) {
        margin: 0;
        flex-direction: column;
      }
    `,
    title: css`
      color: ${grayShades[0]} !important;
      padding-bottom: 1.5rem;
    `,
    subtitle: css`
      color: ${grayShades[0]} !important;
      padding-bottom: 2.313rem;
      @media (max-width: 767px) {
        padding-bottom: 1.5rem;
      }
    `,
    collider: css`
      margin: 2.5rem 0 1.5rem;
      background: ${grayShades[0]} !important;
      text-align: left;
      max-width: 100% !important;
      @media (max-width: 767px) {
        h6 {
          font-weight: 400;
          font-size: 1rem;
        }
    
      }
    `
  })
}

export { Styles }
